import PropTypes from 'prop-types';
import React from 'react';
import { createChainedFunction } from '@atc/create-chained-function';

/**
 * Popup can be used to generate a trigger than when clicked will open a popup window with the specified arguments.
 * The trigger to be used should be passed to the Popup component as a child node.
 * The Popup component also accepts props for the popup windows: url, height, and width.
 * All remaining popup options are standardized.
 *
 */
function Popup(_ref) {
  let {
    url,
    width,
    height,
    children,
    onClick
  } = _ref;
  const handleOnClick = () => {
    window.open(url, 'popup', `height=${height},width=${width},scrollbars=yes,resizable=yes`, false);
  };
  const element = React.Children.only(children);
  return /*#__PURE__*/React.cloneElement(element, {
    onClick: createChainedFunction(handleOnClick, onClick, children.props.onClick)
  });
}
export default Popup;